<div class="upload-container" fxLayout="column">
  <div fxFlex="100%" fxFlexAlign="end">
    @if (displayUploadButton) {
      <button
        mat-button
        [ngClass]="uploadButtonClass"
        (click)="documentUpload.click()"
        [attr.aria-label]="uploadAriaLabel"
      >
        {{ uploadText }}
      </button>
    }
    <input
      type="file"
      id="documentUpload"
      #documentUpload
      ng2FileSelect
      [uploader]="uploader"
      (change)="documentUpload.value = ''"
    />
    @if (displayDocumentScanningMessage) {
      <div
        class="scan-message"
        layout="row"
        layout-sm="column"
        layout-align="space-around"
      >
        Scan in progress.
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
  @if (this.errorMessage) {
    <label class="error-message" fxFlex="100%">{{ this.errorMessage }}</label>
  }
</div>
